:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

.header-base-wrapper {
  background-color: #ffffff;
  position: relative;
  z-index: 1;
  height: var(--header-height);
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: [burger-start] 56px [burger-end] 16px [logo-start] 1fr [logo-end search-start] var(--header-height) [search-end];
}
@media (min-width: 768px) {
  .header-base-wrapper {
    grid-template-columns: [burger-start] 80px [burger-end] 32px [logo-start] 1fr [logo-end meta-start] auto [meta-end] 48px [search-start] var(--header-height) [search-end];
  }
}
@media (min-width: 1200px) {
  .header-base-wrapper {
    grid-template-columns: 32px [logo-start] 1fr [logo-end meta-start] auto [meta-end] 48px [search-start] 22% [search-end];
  }
}
@media (min-width: 1200px) {
  .header-base-wrapper {
    position: relative;
  }
  .header-base-wrapper:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #edf1f4;
    z-index: 1;
  }
}

.burger-wrapper {
  grid-column: burger;
}
@media (min-width: 1200px) {
  .burger-wrapper {
    display: none;
  }
}

.logo-wrapper {
  grid-column: logo;
  display: flex;
  align-items: center;
}

.meta-nav-wrapper {
  grid-column: meta;
  align-items: center;
  padding-block: 8px;
  grid-auto-flow: column;
  gap: 32px;
  display: none;
}
@media (min-width: 768px) {
  .meta-nav-wrapper {
    display: grid;
  }
}

.search-wrapper {
  grid-column: search;
  display: flex;
  align-items: center;
  z-index: 2;
}